import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { V2RoutingModule } from './v2-routing.module';

@NgModule({
  imports: [CommonModule, V2RoutingModule],
  declarations: [],
})
export class V2Module {}
